<template>
  <v-sheet height="calc(100vh - 76px)" class="overflow-hidden my-2 mx-2 position-relative">
    <div class="d-flex h-100 position-relative">
      <div style="z-index: 9" class="position-absolute elevation-16">
        <v-expand-x-transition>
          <engineer-sidebar v-show="leftDrawer" :date="dateRange" :online-status="onlineStatus"
            style="min-width: 300px; max-width: 300px" :active-engineer-uuid.sync="activeEngineerUuid"
            @hoverEngineerMarker="hoverEngineerMarker" />
        </v-expand-x-transition>
        <div style="position: absolute; top: 0; right: -40px; z-index: 10">
          <v-btn @click="leftDrawer = !leftDrawer" depressed width="40" min-height="40"><v-icon size="35"
              color="blue">{{
                leftDrawer ? "mdi-chevron-left" : "mdi-chevron-right"
              }}</v-icon></v-btn>
        </div>
      </div>
      <div class="live-tracking-google-map w-100">
        <div class="map-filter d-flex align-center justify-center">
          <v-checkbox color="cyan" hide-details v-model="showEngineers" style="
              background-color: white;
              min-width: 180px;
              margin: unset;
              padding: 4px 10px;
              border: solid 1px #e2e5ec;
            " label="Show Cleaner" />
          <v-checkbox color="cyan" v-model="showVisits" hide-details style="
              background-color: white;
              min-width: 150px;
              margin: unset;
              padding: 4px 10px;
              border: solid 1px #e2e5ec;
            " label="Show Jobs" class="ml-4 mr-4" />
          <!-- <v-checkbox color="cyan" v-model="showRoutes" hide-details style="
              background-color: white;
              min-width: 150px;
              margin: unset;
              padding: 4px 10px;
              border: solid 1px #e2e5ec;
            " label="Show Routes" class="mr-4" /> -->
          <div style="max-width: 200px">
            <DatePicker v-model="dateRange" hide-details color="cyan" style="background-color: white"
              @change="debounceGetLocations" />
          </div>
        </div>
        <GmapMap ref="map" :center="mapCenter" :zoom="mapZoom" style="width: 100%; height: 85%">
          <template v-if="showRoutes">
            <template v-if="showVisits && visitPath?.length">
              <GmapDirectionsRenderer v-for="(vrow, index) in visitPath" :key="`gmap-directions-renderer-${index}`"
                :origin="vrow.routes.origin" :destination="vrow.routes.destination" :waypoints="vrow.routes.waypoints"
                travelMode="DRIVING" />
            </template>
            <template v-if="showEngineers && engineerPath?.length">
              <GmapPolyline v-for="(prow, index) in engineerPath" :key="`gmap-polyline-${index}`" :path="prow.routes"
                :options="polyLineOption" />
            </template>
          </template>
          <GmapCluster :minimumClusterSize="2" :zoomOnClick="true">
            <template v-if="showEngineers">
              <GmapMarker :key="`gmap-marker-engineer-${index}`" v-for="(row, index) in locations"
                :position="row?.position" :clickable="true" @mouseover="openInfoWindow(index, 'engineer')"
                class="map_marker" :icon="markerIcon(row, index)" />
            </template>
            <template v-if="showVisits">
              <GmapMarker v-for="(row, index) in visits" :key="`gmap-marker-visit-${index}`"
                :position="row?.property?.position" :clickable="true" @mouseover="openInfoWindow(index, 'visit')"
                class="map_marker" :icon="markerIcon(row, index)" />
            </template>
          </GmapCluster>
          <GmapInfoWindow v-if="
            showEngineers &&
            hoveredType === 'engineer' &&
            infoWindowOpened &&
            locations[activeEngineerIndex]?.engineer?.id
          " :position="locations[activeEngineerIndex]?.position" :options="{ pixelOffset: { width: 0, height: -40 } }"
            class="px-0">
            <div class="custom-info-window position-relative" style="min-width: 400px">
              <v-toolbar elevation="0" :color="locations[activeEngineerIndex]?.engineer?.is_online
                ? 'green lighten-5'
                : 'red lighten-5'
                ">
                <v-toolbar-title class="text-h6">
                  <v-list-item>
                    <v-badge bordered bottom :color="locations[activeEngineerIndex]?.engineer?.is_online
                      ? 'green'
                      : 'red'
                      " dot offset-x="10" offset-y="10" class="me-2">
                      <v-avatar size="40">
                        <v-img :src="locations[activeEngineerIndex]?.engineer
                          ?.profile_logo
                          "></v-img>
                      </v-avatar>
                    </v-badge>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        locations[activeEngineerIndex]?.engineer?.display_name
                      }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                        locations[activeEngineerIndex]?.engineer?.designation
                      }}
                        <div>
                          <v-icon size="16">mdi-calendar</v-icon>{{
                            formatDate(locations[activeEngineerIndex]?.date)
                          }}
                        </div>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <div class="total-visits" style="margin-right: 22px">
                  <v-btn @click="closeInfoWindow(true)" icon color="red" class="custom-info-window-close">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <!-- Cleaner Visits Summary -->
                  <div class="d-flex align-center justify-end mb-1">
                    <div class="font-weight-medium me-2">Total Jobs :</div>
                    <v-avatar class="white--text" color="blue" size="25">
                      <span class="font-weight-medium">
                        {{ locations[activeEngineerIndex]?.total_visits ?? 0 }}
                      </span>
                    </v-avatar>
                  </div>
                  <div class="d-flex align-center justify-content-end">
                    <div class="font-weight-medium me-2">Overdue Jobs :</div>
                    <v-avatar class="white--text" color="red" size="25">
                      <span class="font-weight-medium">{{
                        locations[activeEngineerIndex]?.overdue_visits ?? 0
                      }}</span>
                    </v-avatar>
                  </div>
                </div>
              </v-toolbar>
              <div class="px-2 py-2">
                <table v-if="locations[activeEngineerIndex]?.visits?.length" width="100%" cellpadding="0"
                  cellspacing="0">
                  <tr v-for="(visit, index) in locations[activeEngineerIndex]
                    ?.visits" :key="index" :class="index % 2 === 0 ? 'grey lighten-4' : ''">
                    <td>
                      <v-chip :color="visit.status?.color" label x-small text-color="white">
                        {{ visit.barcode }}
                      </v-chip>
                    </td>
                    <td width="150px">
                      <div class="d-inline-block text-truncate" style="max-width: 150px">
                        {{ visit.title }}
                      </div>
                    </td>
                    <td>
                      <v-icon :color="visit.status?.color" small>mdi-map-marker</v-icon>
                      {{ visit.property?.property_address }}
                    </td>
                    <td width="120px">
                      <div class="d-flex align-center">
                        <v-icon class="me-1" small>mdi-clock-outline</v-icon>
                        {{ formatTime(visit.started_at) }} -
                        {{ formatTime(visit.finished_at) }}
                      </div>
                    </td>
                  </tr>
                </table>
                <div v-else class="font-weight-medium text-center py-2">
                  Oops.. No visits found for this cleaner.
                </div>
              </div>
            </div>
          </GmapInfoWindow>
          <GmapInfoWindow v-if="
            showVisits &&
            hoveredType === 'visit' &&
            infoWindowOpened &&
            visits[activeVisitIndex]?.id
          " :position="visits[activeVisitIndex]?.property?.position"
            :options="{ pixelOffset: { width: 0, height: -40 } }" class="px-0">
            <div class="custom-info-window position-relative" style="min-width: 300px">
              <v-toolbar elevation="0" :color="`${markerVisit?.status_color} lighten-5`">
                <v-toolbar-title class="text-h6">
                  Job Visit: #{{ markerVisit.barcode }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <div class="total-visits" style="margin-right: 22px">
                  <v-btn @click="closeVisitInfoWindow" icon color="red" class="custom-info-window-close">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-icon small color="green">mdi-circle</v-icon>
                </div>
              </v-toolbar>
              <div class="px-2 py-2">
                <div class="d-flex align-center justify-content-start mb-2">
                  <div class="fw-600 me-1">Priority:</div>
                  <v-spacer></v-spacer>
                  <v-chip small color="green" outlined label>
                    {{ markerVisit.priority_text }}
                  </v-chip>
                </div>
                <div class="d-flex align-center justify-content-start mb-2">
                  <div class="fw-600 me-1">Status:</div>
                  <v-spacer></v-spacer>
                  <v-chip :color="markerVisit.status_color" small label text-color="white">
                    {{ markerVisit.status_text }}
                  </v-chip>
                </div>
                <div class="d-flex align-center justify-content-start mb-2">
                  <div class="fw-600 me-1">Title:</div>
                  <v-spacer></v-spacer>
                  <div>
                    {{ markerVisit.title }}
                  </div>
                </div>
                <div class="d-flex align-center justify-content-start mb-2">
                  <div class="fw-600 me-1">Time:</div>
                  <v-spacer></v-spacer>
                  <div class="d-flex align-center">
                    <v-icon class="me-1" small>mdi-clock-outline</v-icon>
                    {{ formatTime(markerVisit.started_at) }} -
                    {{ formatTime(markerVisit.finished_at) }}
                  </div>
                </div>
                <div v-if="markerVisit?.engineers?.length" class="d-flex align-center justify-content-start mb-2">
                  <div class="fw-600 me-1">Allocated Cleaner:</div>
                  <v-spacer></v-spacer>
                  <span v-for="(engineer, index) in markerVisit.engineers" :key="index">{{ engineer.display_name }}
                    <span class="mr-2" v-if="markerVisit?.engineers[index + 1]">,</span>
                  </span>
                </div>
              </div>
            </div>
          </GmapInfoWindow>
        </GmapMap>
        <div class="legent-list">
          <div class="mx-auto py-0" style="max-width: calc(100% - 630px)">
            <div class="legends d-flex flex-wrap align-center justify-left my-2">
              <div class="px-2 mr-3 py-1 d-flex align-center border rounded" style="border-color: cyan">
                <span class="text-black font-weight-700">Cleaner :</span>
              </div>
              <div class="px-2 mr-3 py-1 d-flex align-center border rounded">
                <i aria-hidden="true"
                  class="v-icon notranslate mr-1 mdi mdi-access-point theme--light green--text text--darken-1"
                  style="font-size: 15px"></i><span class="text-black">Online</span>
              </div>
              <div class="px-2 mr-3 py-1 d-flex align-center border rounded">
                <i aria-hidden="true"
                  class="v-icon notranslate mr-1 mdi mdi-access-point theme--light red--text text--darken-1"
                  style="font-size: 15px"></i><span class="text-black">Offline</span>
              </div>
            </div>
            <div class="legends d-flex flex-wrap align-center justify-left my-2">
              <div class="px-2 mr-3 py-1 d-flex align-center border rounded" style="border-color: cyan">
                <span class="text-black font-weight-700">Jobs :</span>
              </div>
              <div class="px-2 mr-3 py-1 d-flex align-center border rounded">
                <i aria-hidden="true" class="v-icon notranslate mr-1 mdi mdi-pin theme--light blue--text text--darken-1"
                  style="font-size: 15px"></i><span class="text-black">Open</span>
              </div>
              <div class="px-2 mr-3 py-1 d-flex align-center border rounded" style="border-color: yellow">
                <i aria-hidden="true" class="v-icon notranslate mr-1 mdi mdi-pin theme--light yellow--text"
                  style="font-size: 15px"></i><span class="text-black">In-Progress</span>
              </div>
              <div class="px-2 mr-3 py-1 d-flex align-center border rounded">
                <i aria-hidden="true"
                  class="v-icon notranslate mr-1 mdi mdi-pin theme--light green--text text--darken-1"
                  style="font-size: 15px"></i><span class="text-black">Completed</span>
              </div>
              <div class="px-2 mr-3 py-1 d-flex align-center border rounded">
                <i aria-hidden="true" class="v-icon notranslate mr-1 mdi mdi-pin theme--light red--text text--lighten-1"
                  style="font-size: 15px"></i><span class="text-black">Cancelled</span>
              </div>
            </div>
            <div class="d-flex align-center justify-content-end fw-700 mb-2">
              <span>Powered By</span>
              <v-img contain width="20" max-width="20" height="20" src="https://fsm-24.genicteams.com/favicon-32x32.png"
                class="mx-2"></v-img>
              <span>Genic Teams</span>
            </div>
          </div>
        </div>
      </div>
      <div style="z-index: 9; right: 0" class="position-absolute elevation-16">
        <v-expand-x-transition>
          <visit-sidebar v-show="rightDrawer" :date="dateRange" :engineer-id="engineerId"
            style="min-width: 300px; max-width: 300px" :active-visit-uuid.sync="activeVisitUuid"
            @hoverVisitMarker="hoverVisitMarker" @update:visits="(rows) => (visits = rows)"
            @update:visit-routes="(rows) => (visitPath = rows)" @clearEngineer="() => (engineerId = null)" />
        </v-expand-x-transition>
        <div style="position: absolute; top: 0; left: -40px; z-index: 10">
          <v-btn @click="rightDrawer = !rightDrawer" depressed width="40" min-height="40"><v-icon size="35"
              color="blue">{{
                rightDrawer ? "mdi-chevron-right" : "mdi-chevron-left"
              }}</v-icon></v-btn>
        </div>
      </div>
    </div>
  </v-sheet>
</template>
<script>
import EngineerSidebar from "@/view/pages/live-tracking/engineer-sidebar";
import VisitSidebar from "@/view/pages/live-tracking/visit-sidebar";
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import { QUERY } from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin";
import DatePicker from "@/view/components/DatePicker.vue";
import GmapDirectionsRenderer from "@/view/pages/live-tracking/direction-renderer.vue";
import moment from "moment-timezone";
import AblyMixin from "@/core/plugins/ably.mixin";
import { gmapApi } from "vue2-google-maps";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

const ENGINEER_SVG = `
  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 36">
    <defs>
      <pattern id="imgPattern" patternUnits="userSpaceOnUse" width="20" height="20">
        <image href="{imageUrl}" alt="avatar" width="20" height="20" x="0" y="0" preserveAspectRatio="xMidYMid meet" />
      </pattern>
    </defs>
    <path d="M12 2C7 2 3 6 3 11c0 7.5 9 22 9 22s9-14.5 9-22c0-5-4-9-9-9zm0 13a4 4 0 1 1 0-8 4 4 0 0 1 0 8z" fill="{backgroundColor}" />
    <circle cx="12" cy="11" r="7" fill="url(#imgPattern)" />
  </svg>`;

const DEFAULT_SVG = `
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="32.000000pt" height="32.000000pt" viewBox="0 0 32.000000 32.000000" preserveAspectRatio="xMidYMid meet">
    <g transform="translate(0.000000,32.000000) scale(0.100000,-0.100000)" fill="{backgroundColor}" stroke="none">
      <path d="M113 310 c-15 -6 -20 -15 -16 -30 3 -11 9 -23 14 -26 16 -10 9 -42 -16 -72 -39 -46 -30 -76 25 -84 22 -3 25 -9 28 -45 4 -55 20 -55 24 -1 3 37 6 43 28 46 55 8 64 38 25 84 -29 34 -30 45 -10 84 8 16 11 32 6 37 -13 13 -83 18 -108 7z"/>
    </g>
  </svg>`;

export default {
  name: "live-tracking",
  mixins: [CommonMixin, AblyMixin],
  data() {
    return {
      showEngineers: true,
      showVisits: true,
      showRoutes: false,
      leftDrawer: true,
      rightDrawer: true,
      mapZoom: 12,
      locations: [],
      visits: [],
      engineerPath: [],
      visitPath: [],
      dateRange: moment().format("YYYY-MM-DD"),
      activeEngineerUuid: null,
      activeVisitUuid: null,
      activeEngineerIndex: null,
      activeVisitIndex: null,
      hoveredType: null,
      timeout: null,
      onlineStatus: {},
      engineerId: null,
      infoWindowOpened: false,
      mapCenter: { lat: 1.3264433719068898, lng: 103.89630965516604 },
      defaultMapCenter: { lat: 1.3264433719068898, lng: 103.89630965516604 },
      engineerMap: new Map(),
      visitMap: new Map(),
    };
  },
  components: {
    GmapDirectionsRenderer,
    GmapCluster,
    EngineerSidebar,
    VisitSidebar,
    DatePicker,
  },
  methods: {
    markerIcon(row) {
      const locationType = row?.type;
      const backgroundColor = row?.status_color;
      const imageUrl = row?.engineer?.profile_logo_base64;
      const isEngineer = locationType === "engineer";

      const config = {
        scaledSize: {
          width: isEngineer ? 50 : 30,
          height: isEngineer ? 50 : 30,
        },
        labelOrigin: { x: 12, y: 36 },
      };

      const svgTemplate = isEngineer ? ENGINEER_SVG : DEFAULT_SVG;
      const svgContent = svgTemplate
        .replace("{backgroundColor}", backgroundColor)
        .replace("{imageUrl}", isEngineer ? imageUrl : "");

      return {
        ...config,
        url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
          svgContent
        )}`,
      };
    },
    openInfoWindow(index, type) {
      this.closeInfoWindow();
      this.$nextTick(() => {
        this.hoveredType = type;
        this.activeEngineerIndex = type == "engineer" ? index : null;
        if (type == "engineer") {
          this.activeEngineerUuid =
            this.locations[index]?.engineer?.uuid ?? null;
        }

        this.activeVisitIndex = type == "visit" ? index : null;
        this.activeVisitUuid =
          type == "visit" ? this.visits[index]?.uuid : null;
        this.infoWindowOpened = true;
      });
    },
    closeInfoWindow(force) {
      this.hoveredType = null;
      this.activeEngineerIndex = null;
      this.activeVisitIndex = null;
      this.activeVisitUuid = null;
      this.infoWindowOpened = false;
      this.mapZoom = 12;
      if (force === true) {
        this.engineerId = null;
        this.activeEngineerUuid = null;
      }
      // this.mapCenter = this.defaultMapCenter;
    },
    hoverEngineerMarker(row) {
      this.closeInfoWindow(true);

      if (!row?.uuid || !row?.id) {
        this.engineerId = null;
        this.activeEngineerUuid = null;
        this.activeEngineerIndex = -1;
        return;
      }

      this.hoveredType = "engineer";
      this.engineerId = row.id;
      this.activeEngineerUuid = row.uuid;
      this.activeEngineerIndex = this.engineerMap.get(row.uuid) ?? -1;

      if (this.activeEngineerIndex !== -1) {
        this.infoWindowOpened = true;
        this.mapCenter =
          this.locations[this.activeEngineerIndex]?.position ??
          this.defaultMapCenter;
        // this.mapZoom = 15;
      } else {
        this.activeEngineerIndex = -1;
        // console.warn(`Cleaner with UUID ${row.uuid} not found in locations`);
      }
    },
    hoverVisitMarker(visitUuid) {
      this.closeInfoWindow();

      if (!visitUuid) {
        this.activeVisitUuid = null;
        this.activeVisitIndex = -1;
        return;
      }

      this.hoveredType = "visit";
      this.activeVisitUuid = visitUuid;
      this.activeVisitIndex = this.visitMap.get(visitUuid) ?? -1;

      if (this.activeVisitIndex !== -1) {
        this.infoWindowOpened = true;
        this.mapCenter =
          this.visits[this.activeVisitIndex]?.property?.position ??
          this.defaultMapCenter;
        // this.mapZoom = 15;
      } else {
        this.activeVisitIndex = -1;
        // console.warn(`Visit UUID not found: ${visitUuid}`);
      }
    },
    debounceGetLocations() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getLocations();
        this.getRoutes();
      }, 500);
    },
    getLocations() {
      this.$store
        .dispatch(QUERY, {
          url: "tracking/map/engineers",
          data: { date: this.dateRange },
        })
        .then((response) => {
          this.locations = response?.data ?? [];
        })
        .catch((error) => {
          this.logError(error);
        });
    },
    getOnlineStatus(prop) {
      this.onlineStatus = prop?.data;
      if (this.onlineStatus?.engineerUuid) {
        for (let i = 0; i < this.locations.length; i++) {
          const location = this.locations[i];
          if (location?.engineer?.uuid === this.onlineStatus?.engineerUuid) {
            this.locations[i].engineer.is_online =
              this.onlineStatus?.status ?? false;
          }
        }
      }
    },
    getRoutes() {
      this.engineerPath = [];
      if (!this.showRoutes) return false;
      this.$store
        .dispatch(QUERY, {
          url: "tracking/map/routes",
          data: { date: this.dateRange },
        })
        .then((response) => {
          this.engineerPath = response?.data ?? [];
        })
        .catch((error) => {
          this.logError(error);
        });
    },
  },
  watch: {
    locations: {
      handler(locations) {
        this.engineerMap.clear();
        locations.forEach((location, index) => {
          if (location?.engineer?.uuid) {
            this.engineerMap.set(location.engineer.uuid, index);
          }
        });
      },
      immediate: true,
      deep: true,
    },
    visits: {
      handler(visits) {
        this.visitMap.clear();
        visits.forEach((visit, index) => {
          if (visit?.uuid) {
            this.visitMap.set(visit.uuid, index);
          }
        });
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.debounceGetLocations();

    this.channelSubscribe(
      "presence:userStatus",
      "isOnline",
      this.getOnlineStatus
    );
  },
  beforeDestroy() {
    clearTimeout(this.timeout);

    this.channelUnsubscribe(
      "presence:userStatus",
      "isOnline",
      this.getOnlineStatus
    );
  },
  computed: {
    google: gmapApi,
    polyLineOption() {
      return {
        geodesic: true,
        fillColor: "#0f53ff",
        strokeColor: "#0a11d8",
        strokeOpacity: 0.7,
        strokeWeight: 4,
        icons: [
          {
            icon: { path: this.google?.maps?.SymbolPath?.CIRCLE },
            offset: "100",
            repeat: "15px",
          },
        ],
      };
    },
  },
};
</script>
